import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from 'react-icons/fa';
import instanciaAxios from '../../../miscelaneo/instanciaAxios';
import SpinnerCargando from '../SpinnerCargando';
import FuncionesGenerales from '../FuncionesGenerales';
function TablaCompra({ setCompraSeleccionada = () => {}, descripcion, modo = 'normal', id_entidad_proveedor = null }) {
  const [filtro, setFiltro]     = useState('');
  const [compras, setCompras]     = useState([]);
  const [cargando, setCargando] = useState(true);
  const {formatearFechaHoraInput, formatoMoneda, formatearFechaInput} = FuncionesGenerales()
  const handleRowClick = (compra) => {
   // const compraSeleccionada = [compra.id_compra];
   if (modo === 'ComprasPendientesPorProveedor') {
        setCompraSeleccionada(compra);

   }else{
    setCompraSeleccionada(compra.id_compra);

   }
  };

  useEffect(() => {
    let res
    (async () => {
      try {
        setCargando(true);
        if(modo == 'ComprasPendientesPorProveedor'){
          if(id_entidad_proveedor == null) {
            setCompras([]);
            setCargando(false);
            return;
          }
         res = await instanciaAxios.get('/compra/facturasPendientesProveedor/' + id_entidad_proveedor)

        }else {
          res = await instanciaAxios.get('/compra');
        
        }
        setCompras(res.status === 200 ? res.data : []);

      } catch {
        setCompras([]);
      } finally {
        setCargando(false);
      }
    })();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return compras;
    return compras.filter((comp) =>
        comp?.id_compra.toString().includes(filtro.toLowerCase()) ||
        (comp?.nombre_proveedor || '').toLowerCase().includes(filtro.toLowerCase()) ||
        (comp?.monto_total || '').toLowerCase().includes(filtro.toLowerCase()) ||
        (comp?.fecha_hora || '').toLowerCase().includes(filtro.toLowerCase()) ||
        (comp?.fecha_vencimiento || '').toLowerCase().includes(filtro.toLowerCase()) ||

        (comp?.ncf || '').toLowerCase().includes(filtro.toLowerCase()) 
    );
  }, [filtro, compras]);


const columnasBase = [
  {
    name: 'ID',
    selector: row => row.id_compra,
    sortable: true
  },
  {
    name: 'NCF',
    selector: row => row.ncf,
    sortable: true
  },
  {
    name: 'Proveedor',
    id: 'proveedor', // opcional: útil para identificarla
    selector: row => row.nombre_proveedor,
    sortable: true
  },
  {
    name: 'Monto total',
    selector: row => formatoMoneda(row.monto_total),
    sortable: true,
    right: true
  },
  {
    name: 'Fecha',
    id:'fecha',
    selector: row => formatearFechaInput(row.fecha_hora),
    sortable: true
  },
      {
    name: 'Balance',
    selector: row => row.balance ? formatoMoneda(row.balance) : '0.00',
    sortable: true,
    right: true
  },
    {
    name: 'Vencimiento',
    id: 'vencimiento', // opcional: útil para identificarla
    selector: row => formatearFechaInput(row.fecha_vencimiento),
    sortable: true
  }
];

const columns = columnasBase.filter(col => {
  if (modo === 'ComprasPendientesPorProveedor') {
    return col.id != 'proveedor' && col.id != 'fecha'; // ocultar Proveedor
  } else {
    return col.id != 'vencimiento'; // ocultar Vencimiento
  }
});

  if (cargando) return <SpinnerCargando />;
  if(modo === 'ComprasPendientesPorProveedor' && id_entidad_proveedor == null) {
    return (
      <div className="text-gray-500 text-center">
        Debe seleccionar un proveedor.
      </div>
    );
  }
  else if (compras.length === 0) {
    return (
      <div className="text-gray-500 text-center">
        No se encontraron compras.
      </div>
    );
  }

  return (
    <DataTable
      keyField="id_retencion"
      title={
        <>
          <h2 className="text-xl font-semibold text-center">Compras</h2>
          {descripcion && (
            <p className="text-sm text-gray-500 text-center">{descripcion}</p>
          )}
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      dense
      highlightOnHover
      onRowClicked={handleRowClick}
      noDataComponent={
        <div className="text-gray-500">No se encontraron compras.</div>
      }
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar compra..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
}

export default TablaCompra;
